<template>
    <div class="home-page">
		<Header></Header>
		<div class="content">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('Privacy_Policy')}}</span>
			</div>
			<div class="information">
				<div class="faq-content" v-if="list!=''">
					<div class="">
						<!--<p><span>{{$t('Privacy_Policy')}}</span></p>-->
						<p v-html="list"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {		
        return {
			list:[]
			
		}
    },
	created(){	
		this.getHome();
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/share/policy',null,r =>{
				that.$parent.returnCode(r,function(){
					that.list = r.data.content
					that.$parent.loadModal(false);
				});

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/privicyPolicy.vue